import { Loader2 } from "lucide-react";

/**
 * Auth0 redirect lands here. The SDK's redirect-callback handler (set up in
 * Auth0ProviderWithNavigate) intercepts before render, so this is mostly a
 * loading state.
 */
export default function CallbackScreen() {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <Loader2 className="w-8 h-8 animate-spin" />
      <p className="text-muted-foreground text-sm">Signing in...</p>
    </div>
  );
}
